const SeenIcons = ({ fill = "green" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill={fill}
    width="24"
    height="24"
    viewBox="0 0 18 26"
  >
    <path
      id="SVGRepo_iconCarrier"
      d="M2.305 11.235a1 1 0 0 1 1.414.024l3.206 3.319L14.3 7.289a1 1 0 0 1 1.4 1.422l-8.091 8a1 1 0 0 1-.7.289H6.9a1 1 0 0 1-.708-.3l-3.911-4.051a1 1 0 0 1 .024-1.414ZM20.3 7.289l-7.372 7.289-.263-.273a1 1 0 1 0-1.438 1.39l.966 1a1 1 0 0 0 .708.3h.011a1 1 0 0 0 .7-.289l8.091-8A1 1 0 0 0 20.3 7.289Z"
    ></path>
  </svg>
);

export default SeenIcons;
